import {Injectable} from '@angular/core';
import {HttpService} from '@app/core/services/http.service';
import {AuthService} from '@app/core/services/auth.service';
import {BaseService} from '@app/core/services/base.service';
import {InternationalizationService} from '@app/core/services/internationalization.service';
import {RDate} from '@app/core/models/rDate.model';
import {Store} from '@ngrx/store';
import {IAppState} from '@app/core/store/state/app.state';

@Injectable()
export class DateService extends BaseService {
	constructor(
		public authService: AuthService,
		public interService: InternationalizationService,
		public httpService: HttpService,
		public store: Store<IAppState>
	) {
		super(authService, interService, httpService, store);
	}

	public fresh(...params): RDate {
		if (!params) {
			return new RDate(this.tenantTZ, this.interService);
		}

		return new RDate(this.tenantTZ, this.interService).deserialize(...params);
	}

}
